import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ActiveOrgState = {
  activeOrgId: string | null;
  /**
   * Display name of the active workspace. Only load-bearing when the active org is
   * one the user is NOT a member of — i.e. a PlatformAdmin who switched into another
   * tenant's workspace via the picker. For a member org the shell resolves the name
   * from /me memberships, so this can be null. Set by the workspace picker.
   */
  activeOrgName: string | null;
  /** Set both id + name (from the picker, which knows the selected workspace's name). */
  setActiveOrg: (orgId: string | null, orgName?: string | null) => void;
  /** Set only the id (seed paths that resolve the name elsewhere, e.g. from memberships). */
  setActiveOrgId: (orgId: string | null) => void;
};

export const useActiveOrg = create<ActiveOrgState>()(
  persist(
    (set) => ({
      activeOrgId: null,
      activeOrgName: null,
      setActiveOrg: (orgId, orgName = null) => set({ activeOrgId: orgId, activeOrgName: orgName }),
      setActiveOrgId: (orgId) => set({ activeOrgId: orgId }),
    }),
    {
      name: 'gc-active-org',
    },
  ),
);
